/* línkè · 气泡渐变「流动」驱动（2026-07-12）====================
   Telegram 高级感的真正秘密：渐变布相对**视口**固定，气泡只是开在布上的
   一扇窗——滚动时窗子移动、露出渐变不同高度的一段，颜色就流动起来了。

   浏览器原生的 `background-attachment: fixed` 正是这个语义，但 iOS Safari/PWA
   对它支持稀烂（把背景锚到整个文档而非视口，效果错乱甚至消失——我们在 iOS
   适配里反复吃过它的亏）。所以这里改用 JS 手动实现同一效果，全平台一致可靠：
     每个「你」的气泡：background-size = 满视口高；
     background-position-y = -(气泡相对视口顶部的偏移)。
   用 rAF 节流，只在渐变模式（html[data-user-bubble-grad]）开启时工作。
   ============================================================== */

const GRAD_ATTR = 'data-user-bubble-grad';

/** 给一批气泡刷背景定位；无渐变模式则清掉内联样式（回落 CSS 单色/纯色）。 */
function paintBubbles() {
  const root = document.documentElement;
  const on = root.hasAttribute(GRAD_ATTR);
  const bubbles = document.querySelectorAll('.ch-msg-user .ch-bubble');
  if (!on) {
    bubbles.forEach((b) => {
      b.style.backgroundSize = '';
      b.style.backgroundPosition = '';
    });
    return;
  }
  const vh = window.innerHeight || document.documentElement.clientHeight || 1;
  bubbles.forEach((b) => {
    const top = b.getBoundingClientRect().top; // 气泡顶相对视口
    b.style.backgroundSize = `100% ${vh}px`;
    b.style.backgroundPosition = `0 ${-top}px`;
  });
}

/**
 * 挂上流动驱动。返回 cleanup()。
 * 监听：滚动（capture 抓内层滚动容器）、resize、消息列表 DOM 变化（新消息进来）。
 */
export function installBubbleFlow(listEl) {
  let raf = 0;
  const schedule = () => {
    if (!raf) raf = requestAnimationFrame(() => { raf = 0; paintBubbles(); });
  };

  window.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule);

  // 新消息 / 流式增长 / 图片加载都会改布局 → 重刷
  let mo = null;
  if (listEl && 'MutationObserver' in window) {
    mo = new MutationObserver(schedule);
    mo.observe(listEl, { childList: true, subtree: true, characterData: true });
  }

  schedule();
  return () => {
    window.removeEventListener('scroll', schedule, { capture: true });
    window.removeEventListener('resize', schedule);
    if (mo) mo.disconnect();
    if (raf) cancelAnimationFrame(raf);
  };
}
